import { render, staticRenderFns } from "./PaginationCount.vue?vue&type=template&id=bb6fbfa8&"
import script from "./PaginationCount.vue?vue&type=script&lang=js&"
export * from "./PaginationCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Local\\OSPanel\\domains\\partner8.local\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb6fbfa8')) {
      api.createRecord('bb6fbfa8', component.options)
    } else {
      api.reload('bb6fbfa8', component.options)
    }
    module.hot.accept("./PaginationCount.vue?vue&type=template&id=bb6fbfa8&", function () {
      api.rerender('bb6fbfa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/PaginationCount.vue"
export default component.exports